import { useNavigate } from "react-router-dom";
import { Draw } from "../../../../models/Draw";
//import { EthereumValue } from "../../../../models/EthereumValue";
import {
  ANIMATION_DELAY_MULTIPLIER,
  DRAWS_IN_HOME,
} from "../../../../utils/Constants";
import DrawCard from "../../../miscellaneous/DrawCard";
import EmptyDrawCard from "../../../miscellaneous/EmptyDrawCard";
import Headline from "../../../miscellaneous/Headline";
import { useDialog } from "../../../../hooks/useDialog";
import DrawDialog from "../../../dialogs/DrawDialog";
import { useEffect, useState } from "react";
import { Address } from "viem";

export interface DrawHistoryProps {
  draws: Draw[];
  address?: Address;
}

export default function DrawHistory(props: DrawHistoryProps) {
  const { openDialog, closeDialog } = useDialog();
  const navigate = useNavigate();

  // State for draw amount
  const [drawAmount, setDrawAmount] = useState(DRAWS_IN_HOME);

  // Responsive logic for drawAmount
  useEffect(() => {
    function updateDrawAmount() {
      const width = window.innerWidth;
      if (width >= 1920) {
        setDrawAmount(DRAWS_IN_HOME); // desktops
      } else if (width >= 1280) {
        setDrawAmount(DRAWS_IN_HOME - 1); // laptops
      } else if (width >= 1024) {
        setDrawAmount(DRAWS_IN_HOME - 2); // small laptops
      } else {
        setDrawAmount(DRAWS_IN_HOME); // mobiles and tablets (scrollable)
      }
    }
    updateDrawAmount();
    window.addEventListener("resize", updateDrawAmount);
    return () => window.removeEventListener("resize", updateDrawAmount);
  }, []);

  const drawCards = props.draws.map((draw, index) => (
    <div
      key={index}
      data-aos="fade-left"
      data-aos-delay={(index % drawAmount) * ANIMATION_DELAY_MULTIPLIER}
      className="flex justify-center"
    >
      <DrawCard
        key={index}
        draw={draw}
        onClick={() => onOpenDraw(draw)}
        address={props.address}
      />
    </div>
  ));

  function onSeeMoreDraws(): void {
    navigate("/history");
  }
  function onOpenDraw(draw: Draw): void {
    openDialog(
      <DrawDialog
        draw={draw}
        announce={false}
        address={props.address}
        onClose={closeDialog}
      ></DrawDialog>,
    );
  }

  return (
    drawCards.length > 0 && (
      <div className="flex flex-col justify-center">
        <div className="w-[50%] self-center mb-4 pt-[48px]">
          <Headline value={"DRAW HISTORY"}></Headline>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-full px-7 flex flex-row lg:justify-center justify-start items-stretch gap-2.5 pt-3 pb-3 mx-8 transition-opacity duration-500 overflow-y-hidden overflow-x-auto no-scrollbar">
            {drawCards.length > 0 && drawCards.slice(0, drawAmount)}
          </div>
          <div className="~mt-2/4 self-center">
            <div key={7} data-aos="fade">
              <EmptyDrawCard onClick={onSeeMoreDraws}>SEE MORE</EmptyDrawCard>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
